export class EnvironmentVariables {
    public static readonly ApiUrl: string = import.meta.env.VITE_API_URL;
    public static readonly RedirectUrl: string = import.meta.env.VITE_403_REDIRECT;
    public static readonly UserInfoPath: string = import.meta.env.VITE_USER_INFO_PATH;
    public static readonly PortfolioLink: string = import.meta.env.VITE_SIEMENS_PORTFOLIO_PORTAL_URL;
}
